/// <reference types="@types/googlemaps" />

import { Component, ViewChild, AfterViewInit, Input, ElementRef, OnChanges, SimpleChanges, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CollectibleType } from '@portals/api';
import { BaseComponent } from '@portals/core';
// import { ClusterManager } from '@agm/js-marker-clusterer';
import { AgmMap, LatLngLiteral } from '@agm/core';
import { MapData } from '@portals/api';
import { CollectiblesState, DashboardFilterData } from '@portals/store';
import { NotificationsState } from '@portals/store';
import { NotificationPreviewComponent } from '../../notification-preview';
import { DialogPosition, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { finalize } from 'rxjs';

function generateUUID(): string {
	// Generate a random hexadecimal string for each section of the UUID

	const section = () => Math.floor(Math.random() * 0x10000).toString(16);

	// Format the UUID as xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
	return section() + section() + '-' + section() + '-4' + section().substr(0, 3) + '-' + ((Math.random() * 0x10000) | 0x8000).toString(16) + section().substr(0, 3) + section() + section();
}
interface CityData {
	city: string;
	country: string | null;
	count: number;
}
@Component({
	selector: 'portals-dashboard-maps',
	templateUrl: './maps.component.html',
	styleUrls: ['./maps.component.scss'],
})
export class MapsComponent extends BaseComponent implements AfterViewInit {
	@ViewChild('notifyIcon', { static: true }) notifyIconRef!: ElementRef;
	@ViewChild('scrollTrigger') scrollTrigger!: ElementRef<HTMLElement>;
	@ViewChild('postInfo', { static: true }) postInfoRef!: ElementRef;
	@ViewChild(AgmMap) agmMap: AgmMap | undefined; // Initialize it to undefined
	@Input() projectID!: number;
	@Input() timeframe = 'yearly';
	@Input() currentFilters!: any;
	currentMarker: MapData | null = null;
	postsN: MapData[] = [];
	formLoading = false;

	@Input() filterData!: DashboardFilterData;
	private heatmap: any = null;
	private map: any = null;
	constructor(public collectibles: CollectiblesState, private renderer: Renderer2, private deviceService: DeviceDetectorService, public dialog: MatDialog, private cdr: ChangeDetectorRef) {
		super();
	}
	previewDialog!: MatDialogRef<NotificationPreviewComponent>;
	mousePosition = 0;
	mouseInbound!: boolean;
	videoPlaying = false;
	mapHeight = 500;
	stackedPosts: Map<string, MapData[]> = new Map();
	heatmapDataI: LatLngLiteral[] = [];
	locationData: CityData[] = [];

	ngOnChanges(changes: SimpleChanges) {
		if (changes['currentFilters']) {
			const previousValue = changes['currentFilters'].previousValue;
			const currentValue = changes['currentFilters'].currentValue;

			if (!this.isEqual(previousValue, currentValue)) {
				this.getChart(this.timeframe, currentValue);
				this.cdr.detectChanges();
			}
		}
	}
	private isEqual(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	ngAfterViewInit() {
		this.getChart(this.timeframe, this.filterData);
	}
	async getChart(timeframe: any, filters: any) {
		this.formLoading = true;
		this.subscribe(
			this.collectibles.getHeatMapData(timeframe, this.projectID, filters).pipe(
				tap((mainData) => {
					const heatmapData: LatLngLiteral[] = mainData.allPoints.map((value: any) => ({
						lat: value.latitude,
						lng: value.longitude,
					}));
					this.postsN = mainData;
					// this.initializeHeatmap(heatmapData);
					this.heatmapDataI = heatmapData;
					this.initializeHeatmap(heatmapData);
					this.locationData = mainData.cityCounts;
			}),
				finalize(() => {
					this.formLoading = false;
				})
			)
		);
	}
	getBarWidth(count: number): number {
		const maxCount = Math.max(...this.locationData.map((item: any) => item.count));
		return (count / maxCount) * 100;
	}
	onMapLoad(mapInstance: google.maps.Map): void {
		this.map = mapInstance;
	}

	initializeHeatmap(heatmapData: LatLngLiteral[]) {
		console.log(heatmapData);
		const darkMapStyle = [
			{ elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
			{ elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
			{ elementType: 'labels.text.fill', stylers: [{ color: '#212121' }] },
			{ elementType: 'labels.text.stroke', stylers: [{ color: '#fafafa' }] },
			{
				featureType: 'administrative.land_parcel',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#bdbdbd' }],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [{ color: '#cfcfcf' }],
			},
			{
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#616161' }],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [{ color: '#bdbdbd' }],
			},
			{
				featureType: 'poi.park',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#757575' }],
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [{ color: '#ffffff' }],
			},
			{
				featureType: 'road.arterial',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#424242' }],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [{ color: '#cccccc' }],
			},
			{
				featureType: 'road.highway',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#616161' }],
			},
			{
				featureType: 'road.local',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#757575' }],
			},
			{
				featureType: 'transit.line',
				elementType: 'geometry',
				stylers: [{ color: '#d6d6d6' }],
			},
			{
				featureType: 'transit.station',
				elementType: 'geometry',
				stylers: [{ color: '#cfcfcf' }],
			},
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{ color: '#80d8ff' }],
			},
			{
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#01579b' }],
			},
		];
		if (heatmapData.length === 0) {
			console.warn('No heatmap data provided');
			return;
		}

		// Apply the custom style to the map
		this.map.setOptions({ styles: darkMapStyle });

		// Create the heatmap layer with custom gradient
		this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData.map((location) => new google.maps.LatLng(location.lat, location.lng)),
			map: this.map,
			radius: 20,
		});
		// Find the bounding box of all points
		const bounds = new google.maps.LatLngBounds();
		heatmapData.forEach((location) => {
			bounds.extend(new google.maps.LatLng(location.lat, location.lng));
		});

		// Set the center and zoom level
		this.map.fitBounds(bounds);

		// Optional: adjust zoom level based on the size of the bounding box
		const zoomChangeBoundsListener = google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
			const currentZoom = this.map.getZoom();
			if (currentZoom && currentZoom > 15) {
				this.map.setZoom(15); // Adjust this value as needed
			}
		});

		// Find the area with the highest concentration of points
		const gridSize = 0.1; // Size of each grid cell in degrees
		const pointCounts: { [key: string]: number } = {};
		let maxCount = 0;
		let maxCountLocation: LatLngLiteral | null = null;

		heatmapData.forEach((location) => {
			const gridKey = `${Math.floor(location.lat / gridSize)},${Math.floor(location.lng / gridSize)}`;
			pointCounts[gridKey] = (pointCounts[gridKey] || 0) + 1;
			if (pointCounts[gridKey] > maxCount) {
				maxCount = pointCounts[gridKey];
				maxCountLocation = location;
			}
		});

		// Center the map on the area with the highest concentration of points
		if (maxCountLocation) {
			this.map.setCenter(maxCountLocation);
		}
	}
	protected readonly CollectibleType = CollectibleType;
}
